import * as React from 'react';
import { GraphqlQuery } from 'requestapijs';
import { match } from 'react-router';
import { History } from 'history';
import { Loading } from 'sha-el-design/lib';
import { nestedAccess } from 'sha-el-design/lib/helpers';
import { questionDetailsQuery } from './constant';
import { AddQuestion } from './AddQuestion';
import { QuestionNode } from '../../../../schema';

export class EditQuestion extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <GraphqlQuery
        variables={{ id: this.props.match.params.id }}
        queryString={questionDetailsQuery}
        render={(response: { question: QuestionNode }, error, loading) => {
          if (error) {
            return <div>Something went wrong</div>;
          }
          const question = (nestedAccess(response, 'question')) as QuestionNode;
          return (
            <Loading
              isLoading={!question}
              render={() => (
                // AddQuestion renders the whole page chrome itself (title,
                // breadcrumbs, back arrow) and switches to edit copy when the
                // question has an id -- the old Card-with-a-Back-button
                // wrapper here just double-framed it.
                <AddQuestion question={question} />
              )}
            />
          );
        }}
      />
    );
  }
}

interface State {
}

interface Props {
  match: match<{ id: string }>;
  history: History;
}
